import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { RouterModule } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
//import { SearchEmployeeComponent } from '../search-employee/search-employee.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-employee-loan',
  templateUrl: './employee-loan.component.html',
  styleUrls: ['./employee-loan.component.css']
})
export class EmployeeLoanComponent implements OnInit {

  employee_id: string;
  name: string;
  employee_no: string;
  employee_loan: number;
  total: number;
  //branch_id: string;

  //addDialogRef: MatDialogRef<SearchEmployeeComponent>;
  @ViewChild(MatSort) sort: MatSort;

  model = {
    'table_name': 'emp_loan', 'emp_loan_id': '0', 'employee_no': '0', 'type': '',
    'acct_number': '0', 'loan_date': new Date(), 'amount': '', 'loan_desc': '', 'comment': ''
  };

  search_obj = {
    'placeholder': 'رقم الموظف/ اسم الموظف', 'class_name': 'longField',
    'table_list': [
      {
        'table_name': '`employee`', 'selected_no': 'employee_no',
        'field_list': ['employee_no', 'name', 'name_en']
      }
    ]
  };

  Success_Msg; Error_Msg; Employee_Placeholder; Amount_Msg;
  Type_Msg; Employee_Msg;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, private dialogRef: MatDialogRef<EmployeeLoanComponent>, public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Employee_Placeholder').subscribe((res: string) => {
      this.Employee_Placeholder = res;
    });
    this.search_obj['placeholder'] = this.Employee_Placeholder;

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Amount_Msg').subscribe((res: string) => {
      this.Amount_Msg = res;
    });

    translate.get('Type_Msg').subscribe((res: string) => {
      this.Type_Msg = res;
    });

    translate.get('Employee_Msg').subscribe((res: string) => {
      this.Employee_Msg = res;
    });
  }


  ngOnInit() {
  }

  onChangeSearch = function (search_result: object) {
    // console.log(search_result);
    this.employee_no = search_result['no'];

    if (this.employee_no != '') {
      this.getTotal();
      this.check_employee();
    }
  }

  newTotal() {
    this.total = Number(this.model['amount']) + Number(this.employee_loan);

  }
  /*searchEmployee() {
    this.addDialogRef = this.dialog.open(SearchEmployeeComponent, {
      hasBackdrop: false,
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        if (result != undefined) {
          this.employee_id = result['employee_id'];
          this.name = result['name'];
          this.employee_no = result['employee_no'];
          // this.branch_id = result['branch_id'];
          this.getTotal();
          this.check_employee();
        }
      });
  }*/

  check_employee() {
    document.getElementById("custody").style.display = 'none';
    document.getElementById("loan").style.display = 'none';
    document.getElementById("msg").style.display = 'none';
    let emp_info = [];

    let query = "SELECT * FROM `sub_acct` WHERE `emp_no` = '" + this.employee_no + "' AND `status` = '1'" +
      " AND (`main_acct_no` = '" + this.applicationConstants.main_acct_config['custody'] + 
      "' OR `main_acct_no` = '" + this.applicationConstants.main_acct_config['loan'] + "')";
    let obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        
        emp_info = data.data['list'];

        if (emp_info.length > 0) {
          this.model['acct_number'] = emp_info['0']['sub_acct_number'];
          document.getElementById("info").style.display = 'table';

          if (emp_info.length == 1) {
            if (emp_info['0']['main_acct_no'] == this.applicationConstants.main_acct_config['custody'])
              document.getElementById("custody").style.display = 'inline';
            else if (emp_info['0']['main_acct_no'] == this.applicationConstants.main_acct_config['loan'])
              document.getElementById("loan").style.display = 'inline';
          }
          else {
            document.getElementById("custody").style.display = 'inline';
            document.getElementById("loan").style.display = 'inline';
          }
        }
        else {
          document.getElementById("msg").style.display = 'inline';
          document.getElementById("info").style.display = 'none';
        }
      });
  }

  getTotal() {
    if (this.employee_no != undefined && this.model['type'] != '') {
      let loan_amount = [];
      let query = "SELECT `amount` FROM `emp_loan` WHERE `employee_no` = '" + this.employee_no +
        "' AND`status`='1' AND `type` ='" + this.model['type'] + "' AND `is_paid` = '0'";
      let obj = { cmd: 'getList', query: query };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();

          this.employee_loan = 0;
          loan_amount = data.data['list'];
          if (loan_amount.length != 0) {
            loan_amount.forEach(element => {
              this.employee_loan += Number(element.amount);
            });

            this.total = Number(this.model['amount']) + this.employee_loan;
          }
          else {
            this.employee_loan = 0;
            this.total = Number(this.model['amount']);
          }
        });
    }
  }

  add() {
    if (this.model['type'] == '') {
      alert(this.Type_Msg);
      return;
    }

    if (this.employee_id == undefined || this.employee_id == '') {
      alert(this.Employee_Msg);
      return;
    }

    if (this.model['amount'] == '') {
      alert(this.Amount_Msg);
      return;
    }

    this.model['employee_no'] = this.employee_no;
    let values = [];
    values.push(this.model);

    let obj = { cmd: 'add', values: values };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        if (data.status['type'] == 'success') {
          alert(this.Success_Msg);
          this.dialogRef.close(this.dialog_data);
        }
        else 
          alert(this.Error_Msg);
      });

  }

  cancel() {
    this.dialogRef.close(this.dialog_data);
  }

}
